module.exports = __webpack_public_path__ + "static/img/business_04.e31ce01.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/investCenter/business_04.png
// module id = zBKq
// module chunks = 0